/**
 * Converts a medication name (or any string) into a deterministic, URL-safe slug.
 *
 * Used to resolve medication names to treatment keys in the sidebar content index.
 * See: plans/03_20_2026_sidebar_content_decoupling.md
 *
 * Examples:
 *   "Arakoda (tafenoquine)" → "arakoda-tafenoquine"
 *   "Atovaquone-Proguanil"  → "atovaquone-proguanil"
 *   "Doxycycline"           → "doxycycline"
 *   ""                      → ""
 */
export const toSlug = (name: string): string => {
  if (name === "") return "";

  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
};
